module.exports = __webpack_public_path__ + "img/2.023bd157.jpg";